import RichTextPropertyEditor from "../../../../components/RichTextPropertyEditor";

const Title = ({ handleTitleOnChange, value }: any) => {
  return (
    <div>
      <h2 className="mb-2 text-secondaryMidLight">Title</h2>
      <RichTextPropertyEditor value={value ?? ""} onChange={handleTitleOnChange} />
    </div>
  );
};

export { Title };
